var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMomImageSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5231_3457",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FAAB35"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5231_3457)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5231_3457",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 63,
    width: 29,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2733 82.7894C63.1666 82.3264 62.4723 82.0367 62.4723 82.0367C58.0757 79.7093 58.8517 68.8473 58.8517 68.8473C58.8517 68.8473 54.1772 65.2846 50.4161 63.214V63.0352C50.3622 63.0634 50.3084 63.0954 50.2546 63.1246C50.2003 63.0954 50.1469 63.0634 50.0926 63.0352V63.214C46.3314 65.2846 41.657 68.8473 41.657 68.8473C41.657 68.8473 42.433 79.7093 38.0363 82.0367C38.0363 82.0367 37.3425 82.3264 36.2354 82.7894C38.81 88.462 44.1126 92.3655 50.2546 92.3655C56.3965 92.3655 61.6991 88.462 64.2733 82.7894Z",
    fill: "#A06A4B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5231_3457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.098 82.7894C64.9914 82.3264 64.2971 82.0367 64.2971 82.0367C59.9004 79.7093 60.6764 68.8473 60.6764 68.8473C60.6764 68.8473 56.0019 65.2846 52.2408 63.214V63.0352C52.1869 63.0634 52.1331 63.0954 52.0793 63.1246C52.025 63.0954 51.9716 63.0634 51.9173 63.0352V63.214C48.1562 65.2846 43.4817 68.8473 43.4817 68.8473C43.4817 68.8473 44.2577 79.7093 39.861 82.0367C39.861 82.0367 39.1672 82.3264 38.0601 82.7894C40.6347 88.462 45.9373 92.3655 52.0793 92.3655C58.2212 92.3655 63.5238 88.462 66.098 82.7894Z",
    fill: "#A06A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3122 72.912C61.3122 72.912 52.0988 84.0651 35.515 82.1254C30.3775 81.5246 39.5234 66.7363 39.5234 66.7363L59.0323 68.8051L61.3122 72.912Z",
    fill: "#764D34"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5798 84.3086H63.9659C63.9659 88.2445 57.8427 91.435 50.2893 91.435C42.7355 91.435 36.6118 88.2445 36.6118 84.3086H32.8615C32.8615 84.3086 19.0713 88.0333 19.5526 89.8032C22.6728 101.285 35.2487 109.873 50.2893 109.873C65.2177 109.873 77.7178 101.413 80.9544 90.0596C81.4818 88.2112 67.5798 84.3086 67.5798 84.3086Z",
    fill: "#A2DADD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3888 75.3359C41.3888 75.3359 32.9221 76.0535 32.9221 84.3067C32.9221 92.5598 42.4918 97.3775 50.234 97.0768C52.3922 96.9934 51.5122 87.7157 51.5122 87.7157C51.5122 87.7157 39.7853 89.0445 41.3888 75.3359Z",
    fill: "#26ACAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1204 75.3359C59.1204 75.3359 67.587 76.0535 67.587 84.3067C67.587 92.5598 57.9763 97.3775 50.234 97.0768C48.075 96.9934 48.9969 87.7157 48.9969 87.7157C48.9969 87.7157 60.7238 89.0445 59.1204 75.3359Z",
    fill: "#26ACAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5582 34.0934C57.8303 34.0934 54.8086 31.0712 54.8086 27.3433C54.8086 23.6159 57.8303 20.5938 61.5582 20.5938C65.2861 20.5938 68.3078 23.6159 68.3078 27.3433C68.3078 31.0712 65.2861 34.0934 61.5582 34.0934Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3071 32.3773C45.8101 32.3773 42.1643 28.7315 42.1643 24.2346C42.1643 19.7376 45.8101 16.0918 50.3071 16.0918C54.804 16.0918 58.4498 19.7376 58.4498 24.2346C58.4498 28.7315 54.804 32.3773 50.3071 32.3773Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2129 39.8135C65.0539 39.8135 62.4929 37.2525 62.4929 34.0935C62.4929 30.934 65.0539 28.373 68.2129 28.373C71.3719 28.373 73.9329 30.934 73.9329 34.0935C73.9329 37.2525 71.3719 39.8135 68.2129 39.8135Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3079 47.8467C65.1489 47.8467 62.5884 45.2857 62.5884 42.1267C62.5884 38.9672 65.1489 36.4062 68.3079 36.4062C71.4674 36.4062 74.0279 38.9672 74.0279 42.1267C74.0279 45.2857 71.4674 47.8467 68.3079 47.8467Z",
    fill: "#231F20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7552 55.6573C62.5961 55.6573 60.0352 53.0963 60.0352 49.9373C60.0352 46.7778 62.5961 44.2168 65.7552 44.2168C68.9142 44.2168 71.4752 46.7778 71.4752 49.9373C71.4752 53.0963 68.9142 55.6573 65.7552 55.6573Z",
    fill: "#231F20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M38.951 34.0934C42.6789 34.0934 45.7006 31.0712 45.7006 27.3433C45.7006 23.6159 42.6789 20.5938 38.951 20.5938C35.2231 20.5938 32.2014 23.6159 32.2014 27.3433C32.2014 31.0712 35.2231 34.0934 38.951 34.0934Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2964 39.8135C35.4554 39.8135 38.0164 37.2525 38.0164 34.0935C38.0164 30.934 35.4554 28.373 32.2964 28.373C29.1374 28.373 26.5764 30.934 26.5764 34.0935C26.5764 37.2525 29.1374 39.8135 32.2964 39.8135Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2014 47.8467C35.3605 47.8467 37.9214 45.2857 37.9214 42.1267C37.9214 38.9672 35.3605 36.4062 32.2014 36.4062C29.0424 36.4062 26.4814 38.9672 26.4814 42.1267C26.481 45.2857 29.042 47.8467 32.2014 47.8467Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7537 55.6573C37.9127 55.6573 40.4737 53.0963 40.4737 49.9373C40.4737 46.7778 37.9127 44.2168 34.7537 44.2168C31.5947 44.2168 29.0337 46.7778 29.0337 49.9373C29.0337 53.0963 31.5947 55.6573 34.7537 55.6573Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5231_3457",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 28,
    width: 38,
    height: 48
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9066 38.1048C64.3206 29.1824 55.01 28.2773 51.1307 28.2773H50.0354H48.9396C45.0603 28.2773 35.7502 29.1824 33.1642 38.1048C30.5886 46.9897 29.7355 75.3351 50.0354 75.3351C70.3389 75.3356 69.4817 46.9897 66.9066 38.1048Z",
    fill: "#A06A4B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5231_3457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9066 38.1048C64.3206 29.1824 55.01 28.2773 51.1307 28.2773H50.0354H48.9396C45.0603 28.2773 35.7502 29.1824 33.1642 38.1048C30.5886 46.9897 29.7355 75.3351 50.0354 75.3351C70.3389 75.3356 69.4817 46.9897 66.9066 38.1048Z",
    fill: "#A06A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5376 34.1914C55.5376 34.1914 68.4063 43.2433 61.8689 50.9066C56.7387 56.9209 61.8689 57.2087 61.8689 57.2087C61.8689 57.2087 63.356 68.3294 60.899 71.9501C70.8542 71.4259 100.809 36.954 55.5376 34.1914Z",
    fill: "#764D34"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5045 67.5836C44.0735 67.5836 47.7772 63.8503 47.7772 59.2447C47.7772 54.6396 44.0735 50.9062 39.5045 50.9062C34.9354 50.9062 31.2317 54.6396 31.2317 59.2447C31.2317 63.8503 34.9354 67.5836 39.5045 67.5836Z",
    fill: "#A06A4B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8994 67.5836C65.4685 67.5836 69.1722 63.8503 69.1722 59.2447C69.1722 54.6396 65.4685 50.9062 60.8994 50.9062C56.3299 50.9062 52.6262 54.6396 52.6262 59.2447C52.6262 63.8503 56.3299 67.5836 60.8994 67.5836Z",
    fill: "#A06A4B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9574 55.2034C67.9574 55.2034 68.0094 33.5747 50.6464 33.5747C33.2825 33.5747 41.9644 31.6045 41.9644 31.6045L50.0949 25.947C50.0949 25.947 76.1184 23.3609 67.9574 55.2034Z",
    fill: "#F47C24"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2438 55.2034C32.2438 55.2034 32.1918 33.5747 49.5553 33.5747C57.0571 33.5747 58.604 33.7996 58.2372 31.6045C57.6962 28.3716 50.1068 25.947 50.1068 25.947C50.1068 25.947 24.0833 23.3609 32.2438 55.2034Z",
    fill: "#FAAB35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6304 59.2451C38.4733 59.2451 39.9677 57.7507 39.9677 55.9077C39.9677 54.0648 38.4733 52.5703 36.6304 52.5703C34.7874 52.5703 33.293 54.0648 33.293 55.9077C33.293 57.7507 34.7869 59.2451 36.6304 59.2451Z",
    fill: "#AF8065"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8787 59.2451C65.7216 59.2451 67.2161 57.7507 67.2161 55.9077C67.2161 54.0648 65.7216 52.5703 63.8787 52.5703C62.0357 52.5703 60.5417 54.0648 60.5417 55.9077C60.5417 57.7507 62.0357 59.2451 63.8787 59.2451Z",
    fill: "#AF8065"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2216 52.6697C44.3762 52.1761 44.4715 51.5699 44.4715 50.9062C44.4715 49.273 43.9164 47.9492 43.2321 47.9492C42.5474 47.9492 41.9927 49.273 41.9927 50.9062C41.9927 51.5357 42.0762 52.1164 42.2167 52.5958C42.4347 52.5803 42.6578 52.5703 42.8877 52.5703C43.3594 52.5703 43.8069 52.6068 44.2216 52.6697Z",
    fill: "#231F20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2802 52.6305C58.4275 52.1442 58.5169 51.5516 58.5169 50.9062C58.5169 49.273 57.9618 47.9492 57.2775 47.9492C56.5928 47.9492 56.0376 49.273 56.0376 50.9062C56.0376 51.5516 56.1266 52.1442 56.2739 52.6305C56.595 52.5949 56.9271 52.5703 57.2775 52.5703C57.6278 52.5698 57.9599 52.5949 58.2802 52.6305Z",
    fill: "#231F20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8179 46.4462C45.1053 45.3801 44.0981 44.7109 42.9777 44.7109C41.2223 44.7109 39.7375 46.345 39.2439 48.5948C40.2092 47.0666 41.8915 46.0516 43.8102 46.0516C44.5196 46.0516 45.1956 46.194 45.8179 46.4462Z",
    fill: "#231F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6914 43.8681C55.404 42.802 56.4112 42.1328 57.5316 42.1328C59.2874 42.1328 60.7722 43.7668 61.2658 46.0167C60.3006 44.4885 58.6177 43.4735 56.699 43.4735C55.9892 43.4735 55.3132 43.6158 54.6914 43.8681Z",
    fill: "#231F20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8818 50.9062C50.8818 50.9062 53.2827 56.8881 53.1609 57.7256C52.3206 59.2452 50.8818 59.2452 50.8818 59.2452C50.8818 59.2452 51.6359 57.7562 51.5447 56.6262C51.4767 55.7919 50.8818 50.9062 50.8818 50.9062Z",
    fill: "#764D34"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1787 68.8667C47.1787 68.8667 51.3993 70.8812 54.1454 67.584C54.1454 67.584 53.1838 69.8658 51.2756 70.2937C48.7799 70.853 47.1787 68.8667 47.1787 68.8667Z",
    fill: "#764D34"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1579 68.2771C52.4693 68.2771 54.3428 66.7776 54.3428 64.9278C54.3428 63.078 52.4698 61.5781 50.1579 61.5781C47.8464 61.5781 45.9729 63.078 45.9729 64.9278C45.9729 66.7776 47.8464 68.2771 50.1579 68.2771Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5231_3457",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 61,
    width: 10,
    height: 8
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1579 68.2771C52.4693 68.2771 54.3428 66.7776 54.3428 64.9278C54.3428 63.078 52.4698 61.5781 50.1579 61.5781C47.8464 61.5781 45.9729 63.078 45.9729 64.9278C45.9729 66.7776 47.8464 68.2771 50.1579 68.2771Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5231_3457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5573 63.6328H44.4675V70.3318H60.5573V63.6328Z",
    fill: "#231F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomImageSvg);
export default __webpack_public_path__ + "static/media/momImageSvg.0e28744a.svg";
export { ForwardRef as ReactComponent };